import React from 'react';
import '../styles/StatCard.css';

export default function StatCard({ icon, iconColor = 'blue', label, value }) {
    return (
        <div className="sc-card">
            <div className={`sc-icon sc-icon--${iconColor}`}>{icon}</div>
            <div className="sc-body">
                <div className="sc-label">{label}</div>
                <div className="sc-value">{value}</div>
            </div>
        </div>
    );
}
